import { SpaceValues } from "@/lib/utils/SpaceValues";
import { Space, Box, Heading, Row, Text } from "@stenajs-webui/core";
import { Card, CardBody } from "@stenajs-webui/elements";
import StepBoxBody from "../StepBoxBody";
import { routePairLabelWithDescriptionForTables } from "@/lib/utils/RoutePairLabelWithDescriptionInTable";
import { SpacingValues } from "@/lib/utils/SpacingValues";
import { AgreedVolumeSummary } from "@/gql/graphql";
import { formatThousands } from "@/lib/formatters/numbers";

interface AgreedVolumeSummaryViewProps {
  agreedVolumeSummaries: AgreedVolumeSummary[];
}

export const AgreedVolumeSummaryView = ({
  agreedVolumeSummaries,
}: AgreedVolumeSummaryViewProps) => {
  return (
    <StepBoxBody>
      <Card>
        <CardBody>
          <Box alignItems={"center"}>
            <Heading variant="h3">Agreed Volume</Heading>
            <Space num={SpacingValues.SIXTEEN} />
          </Box>
          <Box display="flex" alignItems="start">
            <Box>
              {agreedVolumeSummaries.map((agreedVolume) => (
                <Row
                  key={`agreed-volume-${agreedVolume.routePairCode}`}
                  gap={SpaceValues.TWENTYFOUR}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  width="100%"
                >
                  {routePairLabelWithDescriptionForTables(
                    agreedVolume.routePairDescription
                  )}
                  <Text textAlign="right">
                    {formatThousands(agreedVolume.agreedVolume)} units
                  </Text>
                </Row>
              ))}
            </Box>
          </Box>
        </CardBody>
      </Card>
    </StepBoxBody>
  );
};
